<div class="grid-wrapper">
  <div class="grid-detail-col-1">
    <app-elevation-section>
      <dx-form [colCount]="8" id="form" labelLocation="top" readOnly="true" [formData]="attachment">
          <dxi-item itemType="group">
            <span cssClass=>{{ languageService.LNG("Label.Attachment") }}</span>
            <h2 style="margin: 0;">{{ attachment.AttachmentNumber }}</h2>
          </dxi-item>
          <dxi-item itemType="group" [colSpan]="3">
            <dxi-item
              dataField="Name"
              editorType="dxTextBox"
              ><dxo-label
                text="{{ languageService.LNG('Label.Projectnumber') }} - {{
                  languageService.LNG('Label.Name')
                }}"
              ></dxo-label
            ></dxi-item>
            <dxi-item
              dataField="Customer"
              editorType="dxTextBox"
              ><dxo-label
                text="{{ languageService.LNG('Label.CustomerNumber') }} - {{
                  languageService.LNG('Label.Name')
                }}"
              ></dxo-label
            ></dxi-item>
          </dxi-item>
          <dxi-item itemType="group" [colSpan]="2">
            <dxi-item
              dataField="Task"
              editorType="dxTextBox"
              ><dxo-label
                text="{{ languageService.LNG('Label.Assignment') }}"
              ></dxo-label
            ></dxi-item>
            <dxi-item
              dataField="RekvNo"
              editorType="dxTextBox"
              ><dxo-label
                text="{{ languageService.LNG('Label.ReqNo') }}/{{ languageService.LNG('Label.Name') }}"
              ></dxo-label
            ></dxi-item>
          </dxi-item>
          <dxi-item itemType="group" [colSpan]="2">
            <dxi-item
              dataField="Comment"
              editorType="dxTextArea"
              [editorOptions]="{ height: 140 }"
              ><dxo-label
                text="{{ languageService.LNG('Label.Comment') }}"
              ></dxo-label
            ></dxi-item>
          </dxi-item>
      </dx-form>
    </app-elevation-section>
  </div>

  <div class="grid-log-col-2">
    <div class="grid-log-wrapper">
      <app-elevation-section>
        <dx-data-grid
          #datagriddx
          class="pointer"
          [dataSource]="attachmentWork"
          [rowAlternationEnabled]="true"
          [showBorders]="true"
          [columnAutoWidth]="true"
          (onEditorPreparing)="onEditorPreparing($event)"
          (onEditingStart)="onEditingStart($event)"
          (onSaving)="onSavingMultiple($event)"
          (onInitNewRow)="onInitNewRow($event)"
          (onCellPrepared)="onCellPrepared($event)"
          (onToolbarPreparing)="onToolbarPreparing($event)"
          (onSelectionChanged)="onSelectionChanged($event)"
        >
          <dxo-editing
            mode="batch"
            [allowUpdating]="allowEdit"
            [allowAdding]="allowEdit"
            [useIcons]="true"
          >
          </dxo-editing>
          <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
          <dxo-paging [pageSize]="5"></dxo-paging>
          <dxo-selection mode="multiple" showCheckBoxesMode="always"> </dxo-selection>

          <dxi-column
            caption="{{ languageService.LNG('Label.From') }}"
          ></dxi-column>
          <dxi-column
            caption="{{ languageService.LNG('Label.To') }}"
          ></dxi-column>
          <dxi-column
            caption="{{ languageService.LNG('Label.Fraction') }}"
          ></dxi-column>
          <dxi-column
            caption="{{ languageService.LNG('Label.Weight.In') }}"
          ></dxi-column>
          <dxi-column
            caption="{{ languageService.LNG('Label.Weight.Out') }}"
          ></dxi-column>
          <dxi-column
            caption="{{ languageService.LNG('Label.Container.Number') }}"
          ></dxi-column>
          <dxi-column
            caption="{{ languageService.LNG('Label.Comment') }}"
          ></dxi-column>

          <div *dxTemplate="let data of 'headerTitle'">
            <span style="font-size: 20px;" >{{this.languageService.LNG("Label.Attachment.Work")}}</span>
          </div>

        </dx-data-grid>
      </app-elevation-section>
    </div>
  </div>
</div>

<app-project-portal-approval-details
  [selectedTimeRecord]="selectedTimeRecord"
  [selectedDateInterval]="selectedDateInterval"
  [selectedProjectId]="selectedProjectId">
</app-project-portal-approval-details>
